import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProfileCompletion } from "../utils/common";
import { SHARED_STYLES } from "../utils/constants";

const ProfileCompletionBanner: React.FC = () => {
  const navigate = useNavigate();
  const completion = getProfileCompletion();

  // ✅ Added state
  const [visible, setVisible] = useState(true);

  if (completion >= 100 || !visible) return null;

  return (
    <div
      style={{
        position: "relative", // ✅ Added
        background: "#FFF4E5",
        ...SHARED_STYLES.bannerContainer,
      }}
    >
      {/* ✅ Close Button Added */}
      <span
        className="banner-close"
        onClick={() => setVisible(false)}
        style={{
          background: "#E8F4FD",
          paddingRight: "40px", // prevent overlap
          ...SHARED_STYLES.bannerCloseButton,
        }}
      >
        ×
      </span>

      <div>
        <strong>Complete your profile ({completion}%)</strong>
        <div style={{ fontSize: "13px", color: "#555" }}>
          Add personal & company details to unlock full features.
        </div>
      </div>

      <button
        style={{
          ...SHARED_STYLES.bannerButton,
        }}
        onClick={() => navigate("/userprofile")}
      >
        Complete Now
      </button>
    </div>
  );
};

export default ProfileCompletionBanner;
